import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

export interface ReadonlyRequestedShipMonthBlockProps {
  requestedShipMonth: Dayjs;
}

const ReadonlyRequestedShipMonthBlock = ({
  requestedShipMonth,
}: ReadonlyRequestedShipMonthBlockProps) => {
  const { t } = useTranslation("orders");
  const theme = useTheme();

  return (
    <Box
      data-testid="readonly-requested-ship-month-block"
      sx={{ textAlign: "left" }}
    >
      <Typography
        sx={{
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          paddingBottom: theme.tokens.FuelSpacing2,
        }}
      >
        {t("orderSummary.header.requestShipMonth")}
      </Typography>
      <Typography data-testid="readonly-requested-ship-month">
        {requestedShipMonth?.format("MMM-YYYY")}
      </Typography>
    </Box>
  );
};

export default ReadonlyRequestedShipMonthBlock;
